import axios from './configAxiosOrganizations';

export const getOneOrganizationWorkerList = async (orgId) => {
	return await axios.get(`/${orgId}/worker/list`);
};
